import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";

/** Vue toastifications */
import "vue-toastification/dist/index.css";
import Toast, { PluginOptions, POSITION } from "vue-toastification";

/** Ddatepicker */
import Datepicker from "@vuepic/vue-datepicker";
import "./assets/datepicker.css";

/** Quill Editor */
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

/** Apex Charts */
import VueApexCharts from "vue3-apexcharts";

/** Locales */
import i18n from "./i18n";

const vue = createApp(App).use(i18n);

const options: PluginOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 2000,
  newestOnTop: true,
};

vue.config.errorHandler = (err, vm, info) => {
  console.log(err, vm, info);
  window.dispatchEvent(new Event("vue-error"));
};

vue.use(router);
vue.use(createPinia());
vue.use(Toast, options);
vue.component("DatePicker", Datepicker);
vue.component("QuillEditor", QuillEditor);
vue.use(VueApexCharts);
vue.mount("#app");
